<div class="no-margin-top w-full">
  <div class="action-header uppercase mt-3 text-light text-sm font-medium">{{ '#FATTENER_INFO.SECTION_TITLE' | translate }}</div>
  <p class="name">{{ fattener()?.name }}</p>
  <p class="label">{{ fattener()?.label }}</p>
  <p class="time">ID: {{ fattener()?.id }}</p>
</div>
